import { render, staticRenderFns } from "./InternalMessageDetailDialogComponent.vue?vue&type=template&id=12dfd256&scoped=true"
import script from "./InternalMessageDetailDialogComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./InternalMessageDetailDialogComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./InternalMessageDetailDialogComponent.vue?vue&type=style&index=0&id=12dfd256&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dfd256",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12dfd256')) {
      api.createRecord('12dfd256', component.options)
    } else {
      api.reload('12dfd256', component.options)
    }
    module.hot.accept("./InternalMessageDetailDialogComponent.vue?vue&type=template&id=12dfd256&scoped=true", function () {
      api.rerender('12dfd256', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dialog/customDialogs/InternalMessageDetailDialogComponent.vue"
export default component.exports